interface IlatLng {
    lat: number;
    lng: number;
}

class Geometry {
    public bounds(polyline: IlatLng[]): any {
        const lower = { lat: 90, lng: 180 };
        const upper = { lat: -90, lng: -180 };
        polyline.forEach((p) => {
            upper.lat = (p.lat > upper.lat) ? p.lat : upper.lat;
            upper.lng = (p.lng > upper.lng) ? p.lng : upper.lng;
            lower.lat = (p.lat < lower.lat) ? p.lat : lower.lat;
            lower.lng = (p.lng < lower.lng) ? p.lng : lower.lng;
        });
        return { ne: { lat: upper.lat, lng: upper.lng }, sw: { lat: lower.lat, lng: lower.lng } };
    }

    public toLatLng(latlngarray: number[]): IlatLng {
        return { lat: latlngarray[0], lng: latlngarray[1] };
    }
}

const geometry = new Geometry();

export default geometry;
